import { useState, useCallback } from 'react';

export const usePopupQueue = () => {
  const [activePopups, setActivePopups] = useState([]);

  const addPopup = useCallback((message, duration = 2000, type = 'default') => {
    const newPopup = {
      id: Date.now() + Math.random(),
      message,
      duration,
      type 
    };

    setActivePopups(prev => {
      const newPopups = [...prev, newPopup];
      return newPopups;
    });

    // Remove this specific popup after its duration
    setTimeout(() => {
      setActivePopups(prev => prev.filter(popup => popup.id !== newPopup.id));
    }, duration);
  }, []);

  const clearAllPopups = useCallback(() => {
    setActivePopups([]);
  }, []);

  return {
    activePopups,
    addPopup,
    clearAllPopups
  };
};